import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import moment from 'moment';

class Corte extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'corte/one', saveUrl: 'corte/save', backUrl: '/Catalogo' },
      new Form([
        Form.Field('date', 'startDate', 'Fecha Inicial', '', [Validators.required], 6),
        Form.Field('date', 'endDate', 'Fecha Final', '', [Validators.required], 6),
      ], ['Descargar Excel'], 'Guias Facturas Pagos'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  onSubmit = async (i, vals) => {
    this.setState({ loading: true });
    const { startDate, endDate } = vals;
    const start = moment(startDate).format('YYYY-MM-DD')
    const end = moment(endDate).format('YYYY-MM-DD')
    const Resp = await Http.get(`reporte/guias-facturas?q=1&start_date=${start}&end_date=${end}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob)
      a.style.display = 'none';
      a.href = url;
      a.download = `reporte_guias_facturas_${start}_${end}.xlsx`;;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      this.setState({ sbOpen: true, sbMsg: 'Ocurrio un error al generar el archivo' });
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Corte)
